import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Styles
import './styles/abstack.scss';
import 'react-toastify/dist/ReactToastify.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Layout
import { MainLayout } from './components/layout';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CasesList from './pages/cases/CasesList';
import CaseForm from './pages/cases/CaseForm';
import CaseDetail from './pages/cases/CaseDetail';
import TasksList from './pages/tasks/TasksList';
import TaskForm from './pages/tasks/TaskForm';
import HearingsList from './pages/hearings/HearingsList';
import HearingForm from './pages/hearings/HearingForm';
import HearingChecklist from './pages/hearings/HearingChecklist';
import UsersList from './pages/users/UsersList';
import UserForm from './pages/users/UserForm';
import Reports from './pages/reports/Reports';
import PortfoliosList from './pages/portfolios/PortfoliosList';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Private Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Cases */}
            <Route path="cases" element={<CasesList />} />
            <Route path="cases/new" element={<CaseForm />} />
            <Route path="cases/:id" element={<CaseDetail />} />
            <Route path="cases/:id/edit" element={<CaseForm />} />

          {/* Tasks */}
          <Route path="tasks" element={<TasksList />} />
          <Route path="tasks/new" element={<TaskForm />} />
          <Route path="tasks/:id/edit" element={<TaskForm />} />

          {/* Hearings */}
          <Route path="hearings" element={<HearingsList />} />
          <Route path="hearings/new" element={<HearingForm />} />
          <Route path="hearings/:id/edit" element={<HearingForm />} />
          <Route path="hearings/:hearingId/checklist" element={<HearingChecklist />} />

          {/* Users */}
          <Route path="users" element={<UsersList />} />
          <Route path="users/new" element={<UserForm />} />
          <Route path="users/:id/edit" element={<UserForm />} />

          {/* Placeholder routes */}
          <Route path="reports" element={<Reports />} />
          <Route path="portfolios" element={<PortfoliosList />} />
          <Route path="settings" element={<ComingSoon title="Configuración" />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      </BrowserRouter>
    </AuthProvider>
  );
};

// Componente temporal para páginas en desarrollo
const ComingSoon: React.FC<{ title: string }> = ({ title }) => (
  <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
    <h2 className="text-muted">{title}</h2>
    <p className="text-muted">Esta sección está en desarrollo</p>
  </div>
);

export default App;